import {CSSProperties, FC} from 'react';


export interface IIconFuelProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconFuel: FC<IIconFuelProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="m18.187 4.146.938 1.84a.587.587 0 0 1 .065.267v6.683a2.956 2.956 0 0 1-2.953 2.953h-.952v2.25a1.444 1.444 0 0 1 1.104 1.402v.872a.587.587 0 0 1-.587.587H4.587A.587.587 0 0 1 4 20.413v-.872c0-.679.472-1.25 1.104-1.402V4.817A1.82 1.82 0 0 1 6.921 3h6.921c.795 0 1.442.647 1.442 1.442v10.273h.953a1.78 1.78 0 0 0 1.779-1.779V10.97h-1.391a.587.587 0 0 1-.587-.587v-1.92c0-1.143.75-2.114 1.784-2.448l-.68-1.335a.587.587 0 1 1 1.045-.534ZM6.92 4.174a.644.644 0 0 0-.643.643V18.1h7.833V4.442a.269.269 0 0 0-.269-.268h-6.92ZM5.174 19.54v.285h10.04v-.285a.268.268 0 0 0-.268-.268H5.442a.269.269 0 0 0-.268.268Zm12.038-9.745h.804V7.198a1.4 1.4 0 0 0-.804 1.266v1.332ZM7.879 4.608h4.63c.594 0 1.076.483 1.076 1.077v2.488c0 .594-.482 1.076-1.076 1.076H7.88a1.077 1.077 0 0 1-1.076-1.076V5.684c0-.593.483-1.076 1.076-1.076Zm.098 3.467h4.434V5.782H7.978v2.293Z" clipRule="evenodd" />
        </svg>
    );
};
